<template>
  <!-- Service Section -->
  <section class="service-section-two">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 aos" data-aos="fade-up">
          <div class="section-heading-two">
            <h2>Featured Services</h2>
            <p>Explore the greates our services. You won’t be disappointed</p>
          </div>
        </div>
        <div class="col-md-6 text-md-end aos" data-aos="fade-up">
          <router-link to="/service-categories/categories" class="btn btn-primary btn-view rounded-pill"
            >View All</router-link
          >
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6">
          <div class="service-widget service-two aos" data-aos="fade-up">
            <div class="service-img">
              <router-link to="/details/service-details">
                <img
                  class="img-fluid serv-img"
                  alt="Service Image"
                  src="@/assets/img/categories/categories-07.jpg"
                />
              </router-link>
              <div class="fav-item">
                <router-link to="/service-categories/categories"
                  ><span class="item-cat">Cleaning</span></router-link
                >
                <a href="javascript:void(0)" class="fav-icon">
                  <i class="feather-heart"></i>
                </a>
              </div>
              <div class="item-info">
                <router-link to="/service-provider/providers"
                  ><span class="item-img"
                    ><img
                      src="@/assets/img/profiles/avatar-01.jpg"
                      class="avatar"
                      alt="User"
                    />
                    Jeny Doe</span
                  ></router-link
                >
              </div>
            </div>
            <div class="service-content">
              <h3 class="title">
                <router-link to="/details/service-details"
                  >Electric Panel Repairing Service</router-link
                >
              </h3>
              <p>
                <i class="feather-map-pin me-2"></i>Chicago, USA<span class="rate"
                  ><i class="feather-phone me-2"></i>301-591-8194</span
                >
              </p>
              <div class="serv-info">
                <div class="rating">
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <span>(10)</span>
                </div>
                <h6>$25.00<span class="old-price">$35.00</span></h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="service-widget service-two aos" data-aos="fade-up">
            <div class="service-img">
              <router-link to="/details/service-details">
                <img
                  class="img-fluid serv-img"
                  alt="Service Image"
                  src="@/assets/img/categories/categories-08.jpg"
                />
              </router-link>
              <div class="fav-item">
                <router-link to="/service-categories/categories"
                  ><span class="item-cat">Construction</span></router-link
                >
                <a href="javascript:void(0)" class="fav-icon">
                  <i class="feather-heart"></i>
                </a>
              </div>
              <div class="item-info">
                <router-link to="/service-provider/providers"
                  ><span class="item-img"
                    ><img
                      src="@/assets/img/profiles/avatar-02.jpg"
                      class="avatar"
                      alt="User"
                    />
                    Nick John</span
                  ></router-link
                >
              </div>
            </div>
            <div class="service-content">
              <h3 class="title">
                <router-link to="/details/service-details"
                  >Toughened Glass Fitting Services</router-link
                >
              </h3>
              <p>
                <i class="feather-map-pin me-2"></i>Montana, USA<span class="rate"
                  ><i class="feather-phone me-2"></i>615-325-1630</span
                >
              </p>
              <div class="serv-info">
                <div class="rating">
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <span>(10)</span>
                </div>
                <h6>$45.00</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="service-widget service-two aos" data-aos="fade-up">
            <div class="service-img">
              <router-link to="/details/service-details">
                <img
                  class="img-fluid serv-img"
                  alt="Service Image"
                  src="@/assets/img/categories/categories-09.jpg"
                />
              </router-link>
              <div class="fav-item">
                <router-link to="/service-categories/categories"
                  ><span class="item-cat">Carpentry</span></router-link
                >
                <a href="javascript:void(0)" class="fav-icon">
                  <i class="feather-heart"></i>
                </a>
              </div>
              <div class="item-info">
                <router-link to="/service-provider/providers"
                  ><span class="item-img"
                    ><img
                      src="@/assets/img/profiles/avatar-03.jpg"
                      class="avatar"
                      alt="User"
                    />
                    james</span
                  ></router-link
                >
              </div>
            </div>
            <div class="service-content">
              <h3 class="title">
                <router-link to="/details/service-details">Wooden Carpentry Work</router-link>
              </h3>
              <p>
                <i class="feather-map-pin me-2"></i>Montana, USA<span class="rate"
                  ><i class="feather-phone me-2"></i>901-489-4357</span
                >
              </p>
              <div class="serv-info">
                <div class="rating">
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <i class="fas fa-star filled me-1"></i>
                  <span>(10)</span>
                </div>
                <h6>$45.00</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Service Section -->

  <!-- Work Section -->
  <section class="work-section-two">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading sec-header aos" data-aos="fade-up">
            <h2>How It Works</h2>
            <p>Aliquam lorem ante, dapibus in, viverra quis</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-4 col-sm-6">
          <div class="work-wrap-box work-first aos" data-aos="fade-up">
            <div class="work-icon">
              <span>
                <img src="@/assets/img/icons/work-icon-01.svg" alt="img" />
              </span>
            </div>
            <h5>Choose What To Do</h5>
            <p>
              Customers can browse or search for specific products or services using
              categories, filters, or search bars.
            </p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="work-wrap-box work-last aos" data-aos="fade-up">
            <div class="work-icon">
              <span>
                <img src="@/assets/img/icons/work-icon-02.svg" alt="img" />
              </span>
            </div>
            <h5>Find What You Want</h5>
            <p>
              Customers can add items to their cart. For services, they may select a
              service and proceed to book.
            </p>
          </div>
        </div>
        <div class="col-md-4 col-sm-6">
          <div class="work-wrap-box aos" data-aos="fade-up">
            <div class="work-flex">
              <div class="work-icon">
                <span>
                  <img src="@/assets/img/icons/work-icon-03.svg" alt="img" />
                </span>
              </div>
              <h5>Order Fulfillment</h5>
              <p>
                The Customer fulfills the order by either providing the service to the
                customer & Get Leads from locals
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Work Section -->
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var favIcons = document.querySelectorAll(".fav-icon");
    favIcons.forEach(function (icon) {
      icon.addEventListener("click", function () {
        if (this.classList.contains("selected")) {
          this.classList.remove("selected");
        } else {
          this.classList.add("selected");
        }
      });
    });
  },
};
</script>
